import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import '../styles/pages/ModalLoan.css';

function ModalLoanInterest(props) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(props.value); // brackets array
  const [loanTypeId, setLoanTypeId] = useState(props.loanTypeId); // comes from parent

  useEffect(() => {
    setContent(props.value);
    setLoanTypeId(props.loanTypeId);
  }, [props.value, props.loanTypeId]);

  const onClick = () => setOpen(!open);

  const handleChange = (index, field, value) => {
    const updatedContent = [...content];
    updatedContent[index][field] = value;
    setContent(updatedContent);
  };

  const addRow = () => {
    const newRow = { range: '', interest_rate: '' };
    setContent([...content, newRow]);
  };

  const deleteBracket = async (index, bracketId) => {
    // If bracket has _id, it's stored in DB
    if (bracketId) {
      try {
        await fetch(`/api/loan-rates/${loanTypeId}/brackets/${bracketId}`, {
          method: 'DELETE'
        });
      } catch (error) {
        console.error('Error deleting bracket:', error);
        return;
      }
    }

    // Remove locally
    const updatedContent = content.filter((_, i) => i !== index);
    setContent(updatedContent);
  };

  const deleteEntireLoanType = async () => {
    try {
      await fetch(`/api/loan-rates/${loanTypeId}`, {
        method: 'DELETE'
      });

      if (props.onDelete) props.onDelete(); // optional callback to refresh parent
      setOpen(false);
    } catch (error) {
      console.error('Error deleting loan type:', error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmit(content);
    setOpen(false);
  };

  return (
    <div className="modalDiv">
      <FaEdit onClick={onClick} className="edit-icon" />

      <Popup className="editModal" open={open} closeOnDocumentClick={false}>
        <a className="close" onClick={onClick}>
          &times;
        </a>
        <p className="modal-title">Edit Interest Rates</p>

        <div className="modal-content" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
          <form onSubmit={handleSubmit}>
            {content.map((item, index) => (
              <div key={index} className="modal-row">
                <div className="text-input-container">
                  <label htmlFor={`range-${index}`}>Range</label>
                  <input
                    id={`range-${index}`}
                    value={item.range}
                    onChange={(e) => handleChange(index, 'range', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label htmlFor={`interest_rate-${index}`}>Interest Rate (%)</label>
                  <input
                    type="number"
                    id={`interest_rate-${index}`}
                    value={item.interest_rate}
                    onChange={(e) => handleChange(index, 'interest_rate', parseFloat(e.target.value))}
                  />
                </div>
                <FaTrash
                  className="delete-icon"
                  onClick={() => deleteBracket(index, item._id)}
                  style={{ marginLeft: '10px', cursor: 'pointer', color: 'red' }}
                />
              </div>
            ))}

            <div className="add-btn-container">
              <FaPlus onClick={addRow} className="add-btn" />
            </div>

            <button type="submit" className="submit-btn">
              Submit
            </button>

            <button type="button" className="delete-type-btn" onClick={deleteEntireLoanType}>
              Delete Entire Loan Type
            </button>
          </form>
        </div>
      </Popup>
    </div>
  );
}

export default ModalLoanInterest;
